// extracted by mini-css-extract-plugin
export var callCard = "_n6-0";
export var callMessageButton = "_n6-1";
export var helpIcon = "_n6-3";
export var helpIconContainer = "_n6-4";
export var verticalDivider = "_n6-2";